import { Subscription } from "rxjs";
import apiService from "../api/ApiService";
import { logD } from "@blacknut/logging/dist";
import { ApiError, createUserAgentString, Token } from "../model";
import { RemoteNotification } from "../model/RemoteNotification";
import { NotificationService } from "./NotificationService";
export enum MessageKind {
  REQ_HELLO = "helloReq",
  RESP_HELLO = "helloResp",
  NOTIFICATION_RESP = "notificationResp",
}

export type PushNotificationMessage =
  | {
      kind: MessageKind.REQ_HELLO;
      payload: {
        lang: string;
        userAgent: string;
        token: Token;
      };
    }
  | {
      kind: MessageKind.RESP_HELLO;
      payload: unknown;
      status: number;
      error?: ApiError;
    }
  | {
      kind: MessageKind.NOTIFICATION_RESP;
      payload: {
        notification: RemoteNotification;
      };
      status: number;
    };

const TAG = "PushNotificationService";
class PushNotificationService extends NotificationService {
  private subscription: Subscription | undefined;
  constructor() {
    super();
  }
  public connect() {
    logD(TAG, "In connect %o", apiService.userToken?.accessToken);
    this.subscription = apiService.onTokenRenewed().subscribe(({ type }) => {
      logD(TAG, "Token renewed. ");
      if (type === "user" && this.ws) {
        this.disconnect();
        this.connect();
      }
    });
    this._connect(MessageKind.REQ_HELLO, MessageKind.RESP_HELLO, {
      lang: apiService.locale,
      userAgent: createUserAgentString(apiService.userAgent),
      accessToken: apiService.userToken?.accessToken,
    });
  }

  public disconnect() {
    super.disconnect();
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = undefined;
    }
  }
}

const notificationService = new PushNotificationService();
export default notificationService;
export { PushNotificationService };
